var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-635 -952)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(635 952)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(641 958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.631,215.4a7.017,7.017,0,0,0-2.129-4.793,1.325,1.325,0,0,0-1.854-.014l-.012.012a1.333,1.333,0,0,0,.026,1.868,4.472,4.472,0,0,1-3.1,7.617,4.678,4.678,0,0,1-3.241-1.3,1.315,1.315,0,0,0-.936-.389h0a1.312,1.312,0,0,0-.906,2.259,7.133,7.133,0,0,0,5.049,2.126h.035a7.043,7.043,0,0,0,7.067-6.84Z",
    transform: "translate(-172.66 -203.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.528,214.006a4.476,4.476,0,0,1,6.308-6.352l.174.184a1.314,1.314,0,0,0,1.855-.09,1.339,1.339,0,0,0-.092-1.859,7.071,7.071,0,0,0-4.21-2.072l-1.771,0a7.076,7.076,0,0,0-6.132,6.187l0,1.721a7.058,7.058,0,0,0,1.97,4.094l.135.134a1.3,1.3,0,0,0,.92.4h.029a1.3,1.3,0,0,0,.908-.364,1.365,1.365,0,0,0,.154-.178,1.208,1.208,0,0,0,.253-.774,1.363,1.363,0,0,0-.427-.964Z",
    transform: "translate(-172.66 -203.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.007,216.844a1.333,1.333,0,0,0,.473.087,1.311,1.311,0,0,0,.893-.346l.106-.1a1.315,1.315,0,0,0-.067-1.788l-4.682-4.686a1.322,1.322,0,0,0-1.846.008,1.35,1.35,0,0,0-.388.926l.01.077a1.3,1.3,0,0,0,.376.854l4.721,4.72A1.386,1.386,0,0,0,184.007,216.844Z",
    transform: "translate(-172.66 -203.817)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copyLink.b58d687ef0a33bac1527d98328611ed9.svg";
export { ForwardRef as ReactComponent };